import { Component, Prop, Vue } from "vue-property-decorator";
import { IUser, Role } from "@/models";
import { Slide } from "vue-burger-menu";
import * as icons from "@/components/icons";
@Component({
    name: "sidebar-app",
    components: {
        Slide,
        "advice-icon": icons.AdviceIcon,
        "commercial-icon": icons.CommercialIcon,
        "toolkit-icon": icons.ToolkitIcon,
        "formal-compliance-icon": icons.FormalComplianceIcon,
        "home-icon": icons.HomeIcon,
        "list-icon": icons.ListIcon,
        "settings-icon": icons.SettingsIcon,
        "contact-icon": icons.ContactIcon,
        "archive-icon": icons.ArchiveIcon,
        "statistics-icon": icons.StatisticsIcon,
        "checklist-icon": icons.Checklist,
    },
})

export default class SidebarApp extends Vue {
    @Prop({ required: true })
    public user: IUser;

    public get userName(): string {
        return this.user?.name;
    }

    public get isAdmin(): boolean {
        return this.user?.role === Role.Admin;
    }

    public get isUser(): boolean {
        return this.user?.role === Role.User;
    }

    public get isVip(): boolean {
        return this.user?.role === Role.Vip;
    }

    public logout(): void {
        this.$store.dispatch("app/logout");
    }
}
